export const required = (value) => {

  if (typeof value === 'number') {

    return value > 0 ? '' : 'This field is required';
  }

  return value ? '' : 'This field is required';
};

export const time = (value) => {
  if (!value) {
    return '';
  }

  const pattern = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
  return pattern.test(value) ? '' : 'Time is invalid';
};
